module.exports = __webpack_public_path__ + "img/food1.672aa917.png";